import './mapleeventgroup3/style';
import FormStructure from './mapleeventgroup3/form_structure';

export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js